import { render } from "./SalesNetwork.vue?vue&type=template&id=3f5c8784&scoped=true&bindings={}"
import script from "./SalesNetwork.vue?vue&type=script&lang=ts"
export * from "./SalesNetwork.vue?vue&type=script&lang=ts"

import "./SalesNetwork.vue?vue&type=style&index=0&id=3f5c8784&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f5c8784"

export default script